import { render, staticRenderFns } from "./tabelapreco.vue?vue&type=template&id=27669ce6"
import script from "./tabelapreco.vue?vue&type=script&lang=js"
export * from "./tabelapreco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports